
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  outline: none;
  display: block;
}

.core-dropdown-item {
  display: flex;
  align-items: center;
  color: var(--slh-color-neutral-shade-60, #62779F);
  padding-top: 8px;
  padding-right: 32px;
  padding-bottom: 8px;
  padding-left: 16px;
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  min-height: var(--slh-base-xxs-line-height, 24px);
  font-family: var(--slh-default-font-family, "Open Sans");
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  cursor: pointer;
}
.core-dropdown-item.selected, .core-dropdown-item:hover {
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.core-dropdown-item.focused {
  background-color: var(--slh-color-neutral-shade-10, #EBEEF4);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.core-dropdown-item.disabled {
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  cursor: not-allowed;
}
.core-dropdown-item.selectable {
  padding-left: 12px;
  white-space: pre;
}
.core-dropdown-item .checkbox-wrapper {
  display: inline-flex;
  margin-right: 8px;
  min-width: 24px;
}
.core-dropdown-item slot::slotted(.icon-wrapper) {
  fill: currentColor;
}
.core-dropdown-item slot::slotted(span.highlight) {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
.core-dropdown-item slot {
  display: inline-flex;
  flex-flow: wrap;
}

:host-context(.datatable-modal) .core-dropdown-item {
  flex-direction: row-reverse;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 16px;
  padding-left: 32px;
}

:host slh-checkbox:focus, :host slh-checkbox:visited {
  outline: none;
}

:host(:focus-visible) {
  position: relative;
}
:host(:focus-visible) .core-dropdown-item.focused, :host(:focus-visible) .core-dropdown-item.selected {
  background: transparent;
}
:host(:focus-visible) .core-dropdown-item:not(.selectable)::after {
  content: "";
  display: block;
  width: calc(100% - 12px);
  height: 100%;
  position: absolute;
  top: 0;
  left: 6px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 4px;
  box-sizing: border-box;
}
:host(:focus-visible) .core-dropdown-item.selectable {
  position: relative;
}
:host(:focus-visible) .core-dropdown-item.selectable slh-checkbox::after {
  content: "";
  display: block;
  width: calc(100% - 12px);
  height: 100%;
  position: absolute;
  top: 0;
  left: 6px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 4px;
  box-sizing: border-box;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  top: -1px;
  left: -1px;
}
`;
